export default __webpack_public_path__ + "static/media/NotoSansKR-Bold.bccfd5fe.woff";